/**
 * The Grown-up view toggle's persisted preference — same guarded-localStorage
 * shape as `theme/theme.ts`'s `getThemePreference`/`setThemePreference`
 * (read/write wrapped in `try/catch` so Safari private mode or a disabled
 * `localStorage` degrades to the default rather than throwing).
 *
 * Shared by every surface with a Grown-up disclosure — the free-practice
 * results panel (`results-panel.ts`) and the practice-mode gentle review
 * (`practice.ts`, Task 3 targeted drills) — so opting in on one carries to
 * the other: one preference, not a per-screen copy that can drift out of
 * sync. Originally lived only in `results-panel.ts`; pulled out here when
 * Task 3 added a second Grown-up disclosure that needs the exact same
 * behaviour rather than a re-implementation.
 */
const GROWNUP_KEY = 'swarasense.grownup';

export function getGrownupPref(): boolean {
  try {
    return localStorage.getItem(GROWNUP_KEY) === '1';
  } catch {
    return false;
  }
}

export function setGrownupPref(on: boolean): void {
  try {
    localStorage.setItem(GROWNUP_KEY, on ? '1' : '0');
  } catch {
    // best-effort; nothing to recover here
  }
}
